import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import GetItemById from "../api/GetItemById";
import ItemTableList from "../components/ItemTableList";

const ItemDetail = () => {
  const { itemId } = useParams();
  const [item, setItem] = useState(null);

  // Set Item using Getting Item by Id
  useEffect(() => {
    const getItem = async () => {
      let data = await GetItemById(itemId);
      setItem(data);
    };
    getItem();
  }, [itemId]);
  return (
    <>
      {item ? (
        <section className="body-font text-gray-600">
          <div className="container mx-auto py-8">
            <div className="mb-8 flex flex-col md:flex-row-reverse justify-between md:border-b pb-4">
              <h2 className="text-right text-2xl font-bold p-4">{item.name}</h2>

              <div className="p-4 flex justify-between flex-row-reverse">
                <Link
                  className="p-4 text-lg text-blue-500 font-bold underline"
                  to={`${process.env.PUBLIC_URL}/items`}
                >
                  صفحة المنتجات الرئيسة
                </Link>

                <Link
                  className="p-4 text-lg text-blue-500 font-bold underline"
                  to={`${process.env.PUBLIC_URL}/item/${item.id}/add`}
                >
                  إضافة منتج جديد
                </Link>
              </div>
            </div>
            <div className="-m-4 flex flex-wrap flex-row-reverse">
              <ItemTableList item={item} />
            </div>
          </div>
        </section>
      ) : (
        ""
      )}
    </>
  );
};

export default ItemDetail;
